import { AGWASuiteApiClientBase, ApiResponse } from '../agwasuite-api';
// Import NSwag-generated interfaces directly (simpler than components index access)
import type {
  GetUserDirectoryInput,
  GetUserDirectoryResult,
  GetGroupUserIdsResult,
  GetAllUsersForMemberInput,
  GetAllUsersForMemberResult,
} from '../agwa-api-model';

// ensure type is retained`
export class UserDirectoryApi extends AGWASuiteApiClientBase {
  constructor(baseUrl?: string) {
    super(baseUrl);
  }

  async getUserDirectory(
    userIds: string[]
  ): Promise<ApiResponse<GetUserDirectoryResult>> {
    const distinct = Array.from(new Set((userIds || []).filter(Boolean)));
    if (!distinct.length) {
      // Return an empty result consistent with NSwag interface (users optional)
      return { success: true, status: 200, data: { users: [] } };
    }
    // Endpoint casing normalized to match controller (/api/UserDirectory/Resolve)
    return this.postExecute<GetUserDirectoryInput, GetUserDirectoryResult>(
      '/api/UserDirectory/Resolve',
      { userIds: distinct }
    );
  }

  /** Fetch all user IDs in caller's group. Conditional GET using If-None-Match returns 304 when unchanged. */
  async getGroupUserIds(
    ifNoneMatch?: string
  ): Promise<ApiResponse<GetGroupUserIdsResult>> {
    const resp = await this.get<GetGroupUserIdsResult>(
      '/api/UserDirectory/GroupUserIds',
      {
        headers: ifNoneMatch ? { 'If-None-Match': ifNoneMatch } : undefined,
      }
    );
    return resp;
  }

  /** Fetch all users in a member group as UserDirectoryUserDto, for user picker components. */
  async getAllUsersForMember(
    loginGroupId: string
  ): Promise<ApiResponse<GetAllUsersForMemberResult>> {
    return this.postExecute<
      GetAllUsersForMemberInput,
      GetAllUsersForMemberResult
    >('/api/UserDirectory/GetAllUsersForMember', { loginGroupId });
  }
}
